(function () {
  angular.module('binky.core.promise-utils', []);
})();
